/**
 * Lightweight logger — routes through Sentry in production so client-side
 * warnings/errors show up in your Issues feed, and skips noisy console
 * output in production builds. In dev, still logs to console for local
 * debugging.
 */
import * as Sentry from "@sentry/react";

const isProd = process.env.NODE_ENV === "production";

export const logger = {
  warn(msg, err) {
    if (!isProd) {
      // eslint-disable-next-line no-console
      console.warn(msg, err);
    }
    if (err) Sentry.captureMessage(`${msg}: ${err?.message || err}`, "warning");
    else Sentry.captureMessage(msg, "warning");
  },
  error(msg, err) {
    if (!isProd) {
      // eslint-disable-next-line no-console
      console.error(msg, err);
    }
    if (err instanceof Error) Sentry.captureException(err, { extra: { context: msg } });
    else Sentry.captureMessage(`${msg}: ${err?.message || err}`, "error");
  },
};
